/**
 * Returns true if the environment supports screen sharing via getDisplayMedia.
 * False on mobile browsers, insecure contexts (non-HTTPS), or when navigator is unavailable.
 */
export function isScreenShareSupported(): boolean {
  if (typeof navigator === 'undefined') return false
  const {mediaDevices} = navigator
  return mediaDevices != null && typeof mediaDevices.getDisplayMedia === 'function'
}
